import React from 'react';
import { motion } from 'framer-motion';
import { Flame, Shield, Activity } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 bg-sage-50 relative overflow-hidden" data-id="element-117">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-118">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-sage-300 rounded-full mix-blend-multiply filter blur-3xl" data-id="element-119"></div>
        <div className="absolute top-1/2 right-0 w-64 h-64 bg-beige-300 rounded-full mix-blend-multiply filter blur-3xl" data-id="element-120"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-121">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-122">
          <div className="lg:w-1/2" data-id="element-123">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="relative" data-id="element-124">
              <div className="absolute -inset-4 bg-white/50 rounded-3xl transform -rotate-2" data-id="element-125"></div>
              <div className="bg-white p-8 md:p-10 rounded-3xl shadow-xl relative border border-sage-100" data-id="element-126">
                <h3 className="text-2xl font-serif font-bold text-charcoal mb-6" data-id="element-127">
                  El Ciclo del Cortisol
                </h3>

                <div className="space-y-6" data-id="element-128">
                  <div className="flex items-start gap-4" data-id="element-129">
                    <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-130">
                      <Flame className="w-5 h-5 text-red-500" data-id="element-131" />
                    </div>
                    <div data-id="element-132">
                      <h4 className="font-bold text-charcoal" data-id="element-133">
                        1. Estrés Percibido
                      </h4>
                      <p className="text-sm text-charcoal-light" data-id="element-134">
                        Tu cuerpo detecta "peligro" (trabajo, falta de sueño,
                        dietas).
                      </p>
                    </div>
                  </div>

                  <div className="w-0.5 h-8 bg-gray-200 ml-5" data-id="element-135"></div>

                  <div className="flex items-start gap-4" data-id="element-136">
                    <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-137">
                      <Activity className="w-5 h-5 text-orange-500" data-id="element-138" />
                    </div>
                    <div data-id="element-139">
                      <h4 className="font-bold text-charcoal" data-id="element-140">
                        2. Disparo de Cortisol
                      </h4>
                      <p className="text-sm text-charcoal-light" data-id="element-141">
                        La hormona del estrés inunda tu sistema.
                      </p>
                    </div>
                  </div>

                  <div className="w-0.5 h-8 bg-gray-200 ml-5" data-id="element-142"></div>

                  <div className="flex items-start gap-4" data-id="element-143">
                    <div className="w-10 h-10 bg-sage-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-144">
                      <Shield className="w-5 h-5 text-sage-600" data-id="element-145" />
                    </div>
                    <div data-id="element-146">
                      <h4 className="font-bold text-charcoal" data-id="element-147">
                        3. Retención y Grasa
                      </h4>
                      <p className="text-sm text-charcoal-light" data-id="element-148">
                        Tu cuerpo almacena grasa visceral y retiene líquidos
                        como protección.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="lg:w-1/2" data-id="element-149">
            <span className="text-sage-600 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-150">
              La Ciencia
            </span>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-6" data-id="element-151">
              Cómo el cortisol está{' '}
              <span className="italic text-sage-700" data-id="element-152">secuestrando</span> tu
              cintura
            </h2>
            <p className="text-lg text-charcoal-light mb-6 leading-relaxed" data-id="element-153">
              Cuando tienes niveles crónicos de cortisol, tu cuerpo entra en
              modo de "lucha o huida". Biológicamente, tu cuerpo piensa que hay
              una hambruna o un depredador.
            </p>
            <p className="text-lg text-charcoal-light mb-8 leading-relaxed" data-id="element-154">
              ¿La solución de tu cuerpo?{' '}
              <strong data-id="element-155">
                Ralentizar el metabolismo y acumular grasa en el abdomen
              </strong>{' '}
              (cerca de los órganos vitales) para tener energía rápida. Por eso
              las dietas no funcionan: ¡solo estresan más a tu cuerpo!
            </p>

            <div className="bg-white/60 p-6 rounded-xl border-l-4 border-sage-500" data-id="element-156">
              <p className="font-serif italic text-charcoal-dark text-lg" data-id="element-157">
                "El Protocolo Abdomen Plano 21D no te pide más esfuerzo. Te pide
                paz. Vamos a apagar el interruptor del cortisol."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}